<template>
  <el-dialog :title="getTitle()" :visible="isShowDialog" @close="onClosePopupButtonClick" width="600px">
      <span id="modal-body">
        <el-form ref="form" label-width="150px" style="width: 500px">
          <el-form-item :label="$t('title')">
            <el-input v-model="data.title" autocomplete="off" type="text"></el-input>
          </el-form-item>
          <el-form-item :label="$t('detail')">
           <el-input v-model="data.detail" autocomplete="off" type="textarea" :rows="6"></el-input>
          </el-form-item>
        </el-form>
      </span>
    <span slot="footer" class="dialog-footer">
        <el-button v-if="isEditMode === false" type="primary" @click="onCreateTermAndConditionsButtonClick">{{ $t('create') }}</el-button>
        <el-button v-if="isEditMode === true" type="primary" @click="onSaveTermAndConditionsButtonClick">{{ $t('save') }}</el-button>
        <el-button type="default" @click="onClosePopupButtonClick">{{ $t('cancel') }}</el-button>
      </span>
  </el-dialog>
</template>

<script>
import i18nMessages from '@/translations/Hotel/ManageHotel/TermsAndConditions/components/PopupAddEditTermsAndConditions.i18n'

export default {
  name: 'PopupAddEditTermsAndConditionsHotel',
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function () {
        return { title: '', detail: '' }
      }
    }
  },
  data () {
    return {
      isShowDialog: false
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
    }
  },
  methods: {
    onCreateTermAndConditionsButtonClick: function () {
      this.$emit('onAdded', this.data)
      this.isShowDialog = false
      this.onClosePopupButtonClick()
    },
    onSaveTermAndConditionsButtonClick: function () {
      this.$emit('onSaveChange', this.data)
      this.isShowDialog = false
      this.onClosePopupButtonClick()
    },
    onClosePopupButtonClick: function () {
      this.isShowDialog = false
      this.$emit('onClose')
    },
    getTitle: function () {
      if (this.isEditMode === true) {
        return this.$t('editTermsAndConditions')
      }

      return this.$t('newTermsAndConditions')
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
